import { render, staticRenderFns } from "./PayeeSelection.vue?vue&type=template&id=045131f7&scoped=true&"
import script from "./PayeeSelection.vue?vue&type=script&lang=js&"
export * from "./PayeeSelection.vue?vue&type=script&lang=js&"
import style0 from "./PayeeSelection.vue?vue&type=style&index=0&id=045131f7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045131f7",
  null
  
)

component.options.__file = "PayeeSelection.vue"
export default component.exports